import { HttpClientModule, HTTP_INTERCEPTORS } from "@angular/common/http";
import { NgModule } from "@angular/core";
import { NgSelectModule } from "@ng-select/ng-select";
import { TranslateModule } from "@ngx-translate/core";
import { WrappedTextComponent } from "components/order-management/om-details/wrapped-text/wrapped-text";
import { IonicPageModule } from "ionic-angular";
import { NciIndicatorsService } from "providers/nci-indicators/nci-indicators-service";
import { AuthorizationHttpInterceptor } from "../../../app/authorization/AuthorizationHttpInterceptor";
import { CommonComponentsModule } from "../../../components/common/common-components.module";
import { ComponentsModule } from "../../../components/components.module";
import { ExternalExportOrderModalComponent } from "../external-export-order-modal/external-export-order-modal";
import { QuicksightDashboardReportPageModule } from "../reports/quicksight-dashboard-report/quicksight-dashboard-report.module";
import { ListOrdersPage } from "./list-orders";

@NgModule({
  declarations: [ListOrdersPage, ExternalExportOrderModalComponent],
  imports: [
    IonicPageModule.forChild(ListOrdersPage),
    HttpClientModule,
    ComponentsModule,
    CommonComponentsModule,
    TranslateModule.forChild(),
    NgSelectModule,
    QuicksightDashboardReportPageModule,
  ],
  // TRD-201: NciIndicatorsService is page-scoped here (matches the order-entry-om
  // module's NciAddendumsService convention). list-orders.module did not previously
  // declare any providers; adding the provider array alongside the new service.
  providers: [
    NciIndicatorsService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthorizationHttpInterceptor,
      multi: true,
    },
  ],
  entryComponents: [WrappedTextComponent, ExternalExportOrderModalComponent],
})
export class ListOrdersPageModule {}



// WEBPACK FOOTER //
// ./src/pages/order-managment/list-orders/list-orders.module.ts